var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223199"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 223138"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Profile",
  d: "M6 22.891c0-3.266 4.376-4.081 9.5-4.081 5.152 0 9.5.846 9.5 4.109S20.624 27 15.5 27c-5.151 0-9.5-.846-9.5-4.109ZM9.214 9.349a6.287 6.287 0 1 1 12.573 0 6.287 6.287 0 1 1-12.573 0Z",
  fill: "currentColor"
})))));
export default SvgUser;